import ReactDOMServer from 'react-dom/server';

import React from 'react';
import ESSearchField from 'components/manage/es_search_field';
import moment from 'moment';
import sanitizeHtml from 'sanitize-html';

import Incident from 'resources/incident';

class IncidentsSearchField extends React.Component {
  // Get HTML string for how a typeahead item should be rendered
  _template = suggestion => {
    const view = <IncidentTypeaheadView suggestion={suggestion} />;
    return ReactDOMServer.renderToString(view);
  };

  render() {
    const searchRoute = Incident.searchRoute({ page_id: this.props.page.id });
    const mapResultToUiRoute = suggestion =>
      new URL(
        Routes.page_incident_url(this.props.page, suggestion.id, {
          domain: null,
          subdomain: null,
        }),
      );
    return (
      <ESSearchField
        queryUrl={`${searchRoute}?limit=10&q=%QUERY`}
        pluralizedResultName={'incidents'}
        loadResults={Incident.search}
        mapResultToUiUrl={mapResultToUiRoute}
        template={this._template}
      />
    );
  }
}

class IncidentTypeaheadView extends React.Component {
  _context() {
    const timestamp = this._timestamp();
    const highlight = sanitizeHtml(this._highlightText());
    const innerHtml = `${timestamp} - ${highlight}&#8230;`;

    return (
      <div
        className="context result-context"
        dangerouslySetInnerHTML={{ __html: innerHtml }}
      />
    );
  }

  _timestamp() {
    return moment(this._mostRecentUpdate().created_at).format('l');
  }

  _highlightText() {
    if (this._isUpdateHighlighted()) {
      return this.props.suggestion.highlight['incident_updates.body'][0];
    }

    return this._firstUpdate().body;
  }

  _mostRecentUpdate() {
    return this.props.suggestion.incident_updates[0];
  }

  _firstUpdate() {
    const updates = this.props.suggestion.incident_updates;
    return updates[updates.length - 1];
  }

  _titleText() {
    let displayWords = this.props.suggestion.name;

    if (this._isNameHighlighted()) {
      const text = this.props.suggestion.highlight['name'];
      const highlightItems = $('<span>' + text + '</span>').find('strong');
      const tagClasses = $(highlightItems[0]).attr('class');
      const highlightedWords = _.map(highlightItems, t => {
        return $(t)
          .text()
          .toLowerCase();
      });

      displayWords = this.props.suggestion.name
        .split(' ')
        .map((word, index) => {
          let sanitizedWord = word.toLowerCase().replace(/[!?\.,]/, '');
          if (highlightedWords.indexOf(sanitizedWord) >= 0) {
            return (
              <strong key={sanitizedWord} className={tagClasses}>
                {' '}
                {word}{' '}
              </strong>
            );
          }
          return <span key={sanitizedWord}> {word} </span>;
        });
    }
    return <span className="name">{displayWords}</span>;
  }

  _isUpdateHighlighted() {
    return this._checkFieldHighlight('incident_updates.body');
  }

  _isNameHighlighted() {
    return this._checkFieldHighlight('name');
  }

  _checkFieldHighlight(property) {
    return (
      this.props.suggestion.highlight &&
      this.props.suggestion.highlight.hasOwnProperty(property)
    );
  }

  render() {
    const suggestion = this.props.suggestion;
    const iconClass = suggestion.is_scheduled_maintenance
      ? 'fa-calendar'
      : 'fa-exclamation-triangle';

    return (
      <div className="item search-result es-results">
        <div className="icon-container">
          <i className={`fa ${iconClass}`} />
        </div>
        <div className="result-text-container">{this._titleText()}</div>
        {this._context()}
        <div className="clearfix"></div>
      </div>
    );
  }
}

export default IncidentsSearchField;
